import { css } from '@emotion/react'

const renderDisplayLayout = {
  desktopFeed: 600,
  mobileSingle: 430,
  default: 430,
}

export const baseStyles = css({
  backgroundColor: '#fff',
  border: 'none',
  borderRadius: 0,
  display: 'flex',
  flexDirection: 'column',
  padding: '12px',
  width: 'var(--display-width, 430px)',
})

export { renderDisplayLayout }
